import {authKey} from '../constant/storageKey';
import {decodeToken} from '../Utils/jwt';
import { getFromLocalStorage, setLocalStorage } from '../Utils/local-storage';

export const setToken = (accessToken) => {
    return setLocalStorage(authKey, accessToken);
}

export const getUserInfo = () => {
    const authToken = getFromLocalStorage(authKey);
    if (authToken) {
        const decodedToken = decodeToken(authToken);
        return decodedToken
    } else {
        return null
    }
}
export const isLoggedIn = () => {
    const authToken = getFromLocalStorage(authKey);
    return !!authToken;
}
export const loggedOut = () => {
    return localStorage.removeItem(authKey)
}